import { Nullable } from "sonobello.utilities.react";
import { ITelemetryEvent, TelemetrySeverity } from "sonobello.utilities.react.telemetry";

import { TelemetrySessionTags } from "../../Telemetry/types/ITelemetryClient";

export class ConvertMalformedExperienceEvent implements ITelemetryEvent<TelemetrySessionTags> {
  message = "Convert.com experience missing required key.";
  severity = TelemetrySeverity.Error;
  tags = null;
  miscellaneous: Nullable<Record<string, unknown>>;
  data: { experimentId: string; externalId: string };

  constructor(experimentId: string, externalId: string, experience: Nullable<Record<string, unknown>>) {
    this.data = { experimentId, externalId };
    this.miscellaneous = experience;
  }
}

export class ConvertMalformedVariationEvent implements ITelemetryEvent<TelemetrySessionTags> {
  message = "Convert.com variation payload missing required fields.";
  severity = TelemetrySeverity.Error;
  tags = null;
  miscellaneous: Nullable<Record<string, unknown>>;
  data: { experimentId: string };

  constructor(experimentId: string, variation: Nullable<Record<string, unknown>>) {
    this.data = { experimentId };
    this.miscellaneous = variation;
  }
}
